import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import { themeStructure } from "@vcl";
import { camelToTitleCase } from "@bloglovin/vue-framework";

// "auto", not null — AutoComplete's watcher does `typeof modelValue === "object"`
// before `.value`, and `typeof null === "object"` in JS, so null crashes every button.
export default class IconGap extends BaseOption {
  static userInterfaceComponent = (optionValues, themeId) => {
    let suffix = "px";
    const selectOptions = [
      { value: "auto", label: "Auto", secondaryLabel: "Default" },
    ];

    if (themeId !== undefined) {
      themeStructure.size.spacing.forEach(size => {
        let pixelValue = BaseOption._getStyleValuePropertiesFromTheme("size.spacing", themeId)[size];

        selectOptions.push({
          value: size,
          label: camelToTitleCase(size),
          secondaryLabel: pixelValue,
        });

        if (optionValues["default.icon-gap"] === size) {
          suffix = pixelValue;
        }
      });
    }

    return {
      label: "Icon Gap",
      component: inspectorTools.AUTOCOMPLETE,
      props: {
        allowCustomValue: true,
        showAllResultsOnClick: true,
        suffix: suffix,
        items: selectOptions,
      },
    };
  };

  static defaultValue = "auto";

  static convertConfigValueToCompiledValue(configValue, themeId) {
    if (configValue === "auto" || configValue === null || configValue === undefined) {
      return null;
    }
    let value = BaseOption._getStyleValuePropertiesFromTheme("size.spacing", themeId)[configValue];
    if (!value && typeof configValue === "string") {
      value = configValue;
    }
    if (!value && typeof configValue === "number") {
      value = `${configValue}px`;
    }
    return value || null;
  }
}
